// OGeet Restaurant Week set menu
export const OGEET_SET_MENU_PDF =
  'https://customer-assets-v7afamib.emergentagent.net/job_dbf2a048-f611-4e3a-928e-b07f29ce499b/artifacts/fh08qhw8_OGEET%20SUMMER%20MENU%20YEAR%20END%20final%20.pdf';

export const OGEET_SET_MENU = [
  {
    name: 'Set Menu One',
    courses: '5-Course Gourmet Menu',
    items: [
      { course: 'Amuse-Bouche', dishes: [{ name: 'Thepla Chicken Tikka Tacos' }] },
      { course: '1st Course', dishes: [{ name: 'Cold Mango & Orange Soup', desc: 'with Corn Crackle' }] },
      { course: '2nd Course', dishes: [{ name: 'Rajuli Kebab', desc: 'Vegetable Samosa & Beet Paneer Bombs' }] },
      { course: '3rd Course', dishes: [{ name: 'Khandvi Green Salad', desc: 'Classic Gujarat snack, garden greens, pomegranate & nuts' }] },
      { course: '4th Course', dishes: [{ name: 'Coconut Lime Prawn Saffron Rice', desc: 'Mini Saffron Khulcha & Grilled Paneer, topped Grilled Masala Pineapple' }] },
      { course: '5th Course', dishes: [{ name: 'Shrikhand Parle', desc: 'with Mango Gelato Ice Cream' }] },
    ],
  },
  {
    name: 'Set Menu Two',
    courses: '4-Course Gourmet Menu',
    items: [
      { course: '1st Course', dishes: [{ name: 'Bombay Bhel (N)', desc: 'Street food of Mumbai — puffed rice crispies, fried vermicelli, yogurt spheres, sweet n spicy sauces' }] },
      { course: '2nd Course', dishes: [{ name: 'Samosa Moradabad Dal', desc: 'Cocktail Panjabi Samosa — lentil layered with a spicy fresh cilantro' }] },
      { course: '3rd Course', dishes: [{ name: 'Rogan Chicken', desc: 'Burnt Garlic Rice, Mini Mushroom Khulcha, Grilled Paneer & Masala Pineapple' }] },
      { course: '4th Course', dishes: [{ name: 'Trio Indian Kulfi Ice Cream', desc: 'Pistachio, Malai & Rosé' }] },
    ],
  },
  {
    name: 'Set Menu Three',
    courses: '3-Course Menu',
    items: [
      { course: '1st Course · Starters', dishes: [{ name: 'Butter Chicken Bombs', desc: 'served with Chicken Samosa' }] },
      { course: '2nd Course · Mains', dishes: [{ name: 'Chickpea Chicken Masala', desc: 'Lemon Penne, Masala Naan & Grilled Pineapple' }] },
      { course: '3rd Course · Dessert', dishes: [{ name: 'Chocolate Samosa', desc: 'with Chocolate Ice Cream' }] },
    ],
  },
];
